import { memo, useEffect, useState } from 'react';

// Cursor SVG component
const CursorIcon = memo(({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M5.5 3L19 12L12 13.5L9 20.5L5.5 3Z"
      fill={color}
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
));

CursorIcon.displayName = 'CursorIcon';

// Smooth animated cursor with interpolation
function CollabCursor({ x, y, username, color }) {
  const [smoothPos, setSmoothPos] = useState({ x, y });
  
  // Smooth interpolation for cursor movement
  useEffect(() => {
    const animate = () => {
      setSmoothPos(prev => ({
        x: prev.x + (x - prev.x) * 0.3,
        y: prev.y + (y - prev.y) * 0.3
      }));
    };
    const frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [x, y]);

  return (
    <div
      className="fixed pointer-events-none z-[9999]"
      style={{
        left: smoothPos.x,
        top: smoothPos.y,
        transform: 'translate(-2px, -2px)',
        transition: 'left 0.05s linear, top 0.05s linear'
      }}
    >
      <CursorIcon color={color} />
      {/* Name tag */}
      <div
        className="absolute left-5 top-4 px-2 py-0.5 rounded-md text-[11px] font-medium text-white whitespace-nowrap shadow-md"
        style={{ 
          backgroundColor: color,
          boxShadow: `0 2px 8px ${color}40`
        }}
      >
        {username}
      </div>
    </div>
  );
}

export default function CollabCursors({ cursors }) {
  if (!cursors || Object.keys(cursors).length === 0) return null;

  return (
    <>
      {Object.entries(cursors).map(([sessionId, cursor]) => (
        <CollabCursor
          key={sessionId}
          x={cursor.x}
          y={cursor.y}
          username={cursor.username}
          color={cursor.color}
        />
      ))}
    </>
  );
}
